export const ENV: string = "prod";
export const TELENOR_API_URL: string =
  "https://europe-west1-slog-prod.cloudfunctions.net/telenor-lightweight-api";
export const TELENOR_API_URL_PROD: string =
  "https://europe-west1-slog-prod.cloudfunctions.net/telenor-lightweight-api";
export const TELENOR_PORTAL_SERVICES_URL: string =
  "https://europe-west1-slog-prod.cloudfunctions.net/telenor-portal-services";
export const TELENOR_SKL_PAGE_URL: string =
  "https://skl.telenor.inselo.no/ordrer";
export const TELENOR_SKL_EXPORT_PAGE_URL: string =
  "https://skl.telenor.inselo.no/export";
export const AUTOFLOW_API_URL: string = "https://api.autoflow.inselo.no";
